<template>
<div class="dropdown">
    <ul class="dropdown-ul">
        <li 
        :class="{active: theType[keyName] === item[keyName]}"
        v-for="(item,index) in types" :key="index + 'type'"
        @click="chooseDrop(item)">{{item.name}}</li>
    </ul>
</div>
</template>
<script>
export default {
    name: 'dropdown',
    props: { 
        keyName: {
            type: String,
            default: 'type'
        },
        theType: {
            type: Object,
            default: {}
        },
        types: {
            type: Array | Object,
            default: [] | {}
        }
    },
    data () {
        return {
        }
    },
    methods: {
        chooseDrop (item) {
            this.$emit('chooseDrop', item);
        }
    }
}
</script>
<style lang="scss" scoped>
.dropdown {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 20;
    display: none;
    &-ul {
        width: 88px;
        max-height: 328px;
        background-color: #fff;
        box-shadow: 0px 2px 9px rgba(56, 58, 66, 0.2);
        border-radius: 4px;
        overflow-y: auto;
        text-align: left;
        box-sizing: border-box;
        padding: 2px 0;
        &::-webkit-scrollbar {
            width: 7px;
            height: 7px;
            background-color: transparent;
            }
        &::-webkit-scrollbar-thumb {
            background-color: rgba(172, 169, 169, .65);
            opacity: 0.65;
            border-radius: 4px;
        }
        li {
            padding: 0 18px;
            line-height: 36px;
            color: #474261;
            background-color: #FFFFFF;
            word-break: keep-all;
            font-size: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &:hover {
                background-color: #F6F7F9;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/dropdown.vue